function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import get from 'lodash/get';
import filter from 'lodash/filter';
import PropTypes from 'prop-types';
import cn from 'classnames';
import MiniSearch from 'minisearch';
import withStyles from 'isomorphic-style-loader/withStyles';
import isEmpty from 'lodash/isEmpty';
import some from 'lodash/some';
import { getSlug } from 'helpers/urlTools';
import Avatar from 'components/Avatar';
import ClinicSettings from 'svg/clinic-settings.svg';
import PeopleIcon from 'svg/people-icon.svg';
import PatientsIcon from 'svg/patients-icon.svg';
import AddPatientIcon from 'svg/invite-icon.svg';
import ClinicAdd from 'svg/clinic-add.svg';
import Bell from 'svg/bell.svg';
import intlShape from 'shapes/intlShape';
import App from 'modules/App';
import Account from 'modules/Account';
import Hcp, { PatientsList, SearchClinics, SearchPatients } from 'modules/Hcp';
import * as constants from '../../../constants';
import messages from '../../../messages';
import Sidebar from '../Sidebar';
import MoreClinicItem from './MoreClinicItem';
import styles from './HcpSidebar.pcss';
class HcpSidebar extends Sidebar {
    componentDidMount() {
        const { activeClinicMembership, passphrase } = this.props;
        this.miniSearch = new MiniSearch({
            idField: 'organizationUID',
            fields: [
                'name',
                'clinicId',
                'organizationUID',
                'zipCode',
                'city',
                'clinicIdentifiers',
                'street'
            ],
            extractField: (document, fieldName)=>{
                if (fieldName === 'clinicIdentifiers') {
                    const { customClinicIdentifiersValues } = document;
                    return customClinicIdentifiersValues && customClinicIdentifiersValues.toString();
                }
                return document[fieldName];
            },
            searchOptions: {
                boost: {
                    clinicId: 3,
                    name: 2,
                    city: 2
                },
                fuzzy: 1,
                prefix: true
            }
        });
        this.setMemberships();
        if (passphrase && activeClinicMembership) {
            this.props.onConnect(activeClinicMembership);
            this.props.onFetchMemberships();
            this.onFetchPatients();
        }
    }
    componentDidUpdate(prevProps) {
        const { hcpClinicMemberships, activeOrganizationUID, organizationMemberships, activeClinicMembership, passphrase, route, isConnectToClinicInProgress, hasConnectToClinicErrors } = this.props;
        if (route.name !== prevProps.route.name) {
            this.onHideAllMenu();
        }
        const profilesReferenceKey = get(activeClinicMembership, 'clinic.profilesReferenceKey');
        const prevProfilesReferenceKey = get(prevProps.activeClinicMembership, 'clinic.profilesReferenceKey');
        if (prevProfilesReferenceKey !== profilesReferenceKey && profilesReferenceKey) {
            this.onFetchPatients();
        }
        if (prevProps.hcpClinicMemberships !== hcpClinicMemberships || prevProps.organizationMemberships !== organizationMemberships) {
            this.setMemberships();
        }
        const isOrganizationUIDChanged = prevProps.activeOrganizationUID !== activeOrganizationUID;
        if (passphrase && (isOrganizationUIDChanged || activeClinicMembership && !profilesReferenceKey && !isConnectToClinicInProgress && !hasConnectToClinicErrors)) {
            if (isOrganizationUIDChanged) {
                this.props.onDisconnect();
            }
            this.props.onConnect(activeClinicMembership);
        }
    }
    onFetchPatients() {
        const profilesReferenceKey = get(this.props.activeClinicMembership, 'clinic.profilesReferenceKey');
        if (profilesReferenceKey) {
            this.props.onFetchPatients(this.props.activeClinicMembership);
        }
    }
    setMemberships() {
        this.memberships = [];
        this.membershipOrganizations = [];
        this.props.hcpClinicMemberships.forEach((clinicMembership)=>{
            const membership = _object_spread({}, clinicMembership);
            membership.organizationUID = clinicMembership.clinic.organizationUID;
            membership.status = clinicMembership.membershipStatus;
            membership.clinic.status = clinicMembership.clinic.clinicStatus;
            this.memberships.push(membership);
            this.membershipOrganizations.push(membership.clinic);
        });
        this.props.organizationMemberships.forEach((organizationMembership)=>{
            const membership = _object_spread({}, organizationMembership);
            membership.organizationUID = organizationMembership.organization.organizationUID;
            this.memberships.push(membership);
            this.membershipOrganizations.push(membership.organization);
        });
        this.miniSearch.removeAll();
        this.miniSearch.addAll(this.membershipOrganizations);
    }
    get isEntityActive() {
        const { activeClinicMembership } = this.props;
        if (!activeClinicMembership) return false;
        return !(!activeClinicMembership.membershipStatus || activeClinicMembership.membershipStatus !== 'Active' || activeClinicMembership.clinic.clinicStatus !== 'Active');
    }
    get menuItems() {
        return [
            this.renderMenuFullPatientList(),
            this.renderMenuPatients(),
            this.renderMenuActivePatient(),
            this.renderMenuAddPatient(),
            this.renderHcpSidebarHr(),
            this.renderMenuActiveClinic(),
            this.renderMenuClinicSettings(),
            this.renderMenuMoreClinic(),
            this.renderMenuJoinOrCreateClinic()
        ];
    }
    get menuItemsSelected() {
        return {
            [constants.HCP_MENU_SELECTED_OPTIONS.PATIENTS]: this.renderPatients(),
            [constants.HCP_MENU_SELECTED_OPTIONS.OTHER_CLINICS]: this.renderMoreClinics()
        };
    }
    get activeClinics() {
        const { search } = this.props;
        if (isEmpty(search)) {
            return this.memberships;
        }
        return this.miniSearch.search(search).map((term)=>this.memberships.find((m)=>term.id === m.organizationUID));
    }
    renderMenuFullPatientList() {
        if (!this.isEntityActive) {
            return null;
        }
        const { route } = this.props;
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.fullPatientsList);
        const { organizationUID, name: clinicName } = get(this.props.activeClinicMembership, 'clinic', {});
        const clinicSlug = getSlug(clinicName);
        const fullPatientsListHref = this.context.getUrl('patients-list', {
            clinicSlug,
            organizationUID
        });
        const selected = route.name === 'patients-list';
        const fullPatientIcon = /*#__PURE__*/ _jsx(PeopleIcon, {}, `item-menu-${name}`);
        const fullPatientText = /*#__PURE__*/ _createElement(FormattedMessage, _object_spread_props(_object_spread({}, messages.sidebar.buttons.fullPatientsList), {
            key: `item-menu-expanded-${name}`
        }));
        return this.renderMenuButtonItems(name, [
            fullPatientIcon,
            fullPatientText
        ], undefined, selected, fullPatientsListHref);
    }
    renderMenuPatients() {
        if (!this.isEntityActive) {
            return null;
        }
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.patients);
        const patientsIcon = /*#__PURE__*/ _jsx(PatientsIcon, {}, `item-menu-${name}`);
        const selected = this.isSelectedMenuItem(constants.HCP_MENU_SELECTED_OPTIONS.PATIENTS);
        const patientsText = /*#__PURE__*/ _jsxs(React.Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.patients)),
                this.renderAnimatedChevron(selected)
            ]
        }, `item-menu-expanded-${name}`);
        return [
            this.renderMenuButtonItem(name, 0, patientsIcon, ()=>this.onSelectMenuItem(constants.HCP_MENU_SELECTED_OPTIONS.PATIENTS), selected, null, true),
            this.renderMenuButtonItem(name, 1, patientsText, ()=>this.onSelectMenuItem(constants.HCP_MENU_SELECTED_OPTIONS.PATIENTS), selected, null)
        ];
    }
    renderMenuActivePatient() {
        const { activePatient } = this.props;
        if (!activePatient) return null;
        const name = `${activePatient.firstName} ${activePatient.lastName}`;
        const activePatientIcon = /*#__PURE__*/ _jsx("div", {
            className: "sidebar__avatarContainer",
            children: /*#__PURE__*/ _jsx(Avatar, {
                avatarImg: activePatient.avatar,
                name: [
                    activePatient.firstName,
                    activePatient.lastName
                ],
                className: "sidebar__avatar",
                imgClassName: "sidebar__avatar"
            }, `item-menu-${name}`)
        });
        const activePatientText = /*#__PURE__*/ _jsx(React.Fragment, {
            children: /*#__PURE__*/ _jsx("span", {
                className: "sidebar__elementName sidebar__elementName",
                children: `${activePatient.firstName} ${activePatient.lastName}`
            })
        }, `item-menu-expanded-${name}`);
        return this.renderMenuButtonItems(name, [
            activePatientIcon,
            activePatientText
        ]);
    }
    renderMenuAddPatient() {
        if (!this.isEntityActive) {
            return null;
        }
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.addPatient);
        const { openModalId } = this.props;
        const addPatientIcon = /*#__PURE__*/ _jsx(AddPatientIcon, {}, `item-menu-${name}`);
        const addPatientText = /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.addPatient), `item-menu-expanded-${name}`);
        return this.renderMenuButtonItems(name, [
            addPatientIcon,
            addPatientText
        ], ()=>{
            this.onHideAllMenu();
            this.props.onAddPatient();
        }, openModalId === Hcp.constants.INVITE_PATIENT_MODAL);
    }
    renderHcpSidebarHr() {
        if (!this.isEntityActive) {
            return null;
        }
        return this.renderHr('hcpSidebar');
    }
    renderActiveClinicBadge() {
        const { activeClinicMembership, activeOrganizationMembership } = this.props;
        const status = get(activeOrganizationMembership, 'status') || get(activeClinicMembership, 'membershipStatus');
        const isPending = status === 'Pending';
        if (!isPending) return null;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.sidebar__clinicLogoBadge
        });
    }
    renderActiveClinicIcon() {
        const { activeClinicMembership, activeOrganizationMembership } = this.props;
        const clinic = get(activeOrganizationMembership, 'organization') || get(activeClinicMembership, 'clinic', {});
        const isDeleted = clinic.clinicStatus === 'Deleted' || clinic.clinicStatus === 'Cleared';
        return /*#__PURE__*/ _jsxs("div", {
            className: "sidebar__avatarContainer",
            children: [
                /*#__PURE__*/ _jsx(Avatar, {
                    avatarImg: clinic.logo,
                    name: clinic.name,
                    className: cn('sidebar__clinicLogo', {
                        'sidebar__clinicLogo--deleted': isDeleted
                    }),
                    imgClassName: "sidebar__clinicLogo"
                }, `item-menu-${clinic.name}`),
                this.renderActiveClinicBadge()
            ]
        });
    }
    renderActiveClinicText() {
        const { activeClinicMembership, activeOrganizationMembership } = this.props;
        const clinic = get(activeOrganizationMembership, 'organization') || get(activeClinicMembership, 'clinic', {});
        return /*#__PURE__*/ _jsx("span", {
            className: "sidebar__elementName",
            children: clinic.name
        }, `item-menu-expanded-${clinic.name}`);
    }
    renderMenuActiveClinic() {
        const { activeClinicMembership, activeOrganizationMembership, route } = this.props;
        if (!activeClinicMembership && !activeOrganizationMembership) return null;
        const clinic = get(activeOrganizationMembership, 'organization') || get(activeClinicMembership, 'clinic', {});
        const { organizationUID } = clinic;
        const clinicSlug = getSlug(clinic.name);
        const routeName = 'general-population';
        const selected = route.name === routeName;
        return this.renderMenuButtonItems(clinic.name, [
            this.renderActiveClinicIcon(),
            this.renderActiveClinicText()
        ], undefined, selected, this.isEntityActive ? this.context.getUrl(routeName, {
            clinicSlug,
            organizationUID
        }) : null);
    }
    renderMenuClinicSettings() {
        if (!this.props.isClinicAdmin) {
            return null;
        }
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.clinicSettings);
        const clinic = get(this.props, 'activeClinicMembership.clinic', {});
        const { organizationUID } = clinic;
        const clinicSlug = getSlug(clinic.name);
        const clinicSettingHref = this.context.getUrl('clinic-settings', {
            clinicSlug,
            organizationUID
        });
        const clinicSettingIcon = /*#__PURE__*/ _jsx(ClinicSettings, {}, `item-menu-${name}`);
        const clinicSettingText = /*#__PURE__*/ _jsx(React.Fragment, {
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.clinicSettings))
        }, `item-menu-expanded-${name}`);
        return this.renderMenuButtonItems(name, [
            clinicSettingIcon,
            clinicSettingText
        ], undefined, false, clinicSettingHref);
    }
    renderClinicSettingIcon(moreClinicsCount, name) {
        const { activeClinicMembershipId, hcpClinicMemberships } = this.props;
        const otherClinicMemberships = filter(hcpClinicMemberships, (clinicMembership)=>clinicMembership.clinicHcpMembershipId !== activeClinicMembershipId);
        const hasAnyOtherClinicActiveNotification = some(otherClinicMemberships, ({ hasActiveNotifications })=>hasActiveNotifications);
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                hasAnyOtherClinicActiveNotification && /*#__PURE__*/ _jsx("div", {
                    className: styles.clinicSettingIcon__notificationsBell,
                    children: /*#__PURE__*/ _jsx(Bell, {})
                }),
                this.renderMoreCell(moreClinicsCount, `item-menu-${name}`)
            ]
        });
    }
    renderMenuMoreClinic() {
        const { activeClinicMembershipId, activeOrganizationUID, hcpClinicMemberships, organizationMemberships } = this.props;
        if (!hcpClinicMemberships && !organizationMemberships) return null;
        const moreClinicsCount = filter(hcpClinicMemberships, (clinicMembership)=>clinicMembership.clinicHcpMembershipId !== activeClinicMembershipId).length + filter(organizationMemberships, (organizationMembership)=>organizationMembership.organization.organizationUID !== activeOrganizationUID).length;
        if (moreClinicsCount < 1) return null;
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.otherClinics);
        const isSelected = this.isSelectedMenuItem(constants.HCP_MENU_SELECTED_OPTIONS.OTHER_CLINICS);
        const clinicSettingText = /*#__PURE__*/ _jsxs(React.Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.otherClinics)),
                this.renderAnimatedChevron(isSelected)
            ]
        }, `item-menu-expanded-${name}`);
        const clinicSettingIcon = this.renderClinicSettingIcon(moreClinicsCount, name);
        return this.renderMenuButtonItems(name, [
            clinicSettingIcon,
            clinicSettingText
        ], ()=>this.onSelectMenuItem(constants.HCP_MENU_SELECTED_OPTIONS.OTHER_CLINICS), isSelected);
    }
    renderMenuJoinOrCreateClinic() {
        const name = this.props.intl.formatMessage(messages.sidebar.buttons.addClinic);
        const joinClinicIcon = /*#__PURE__*/ _jsx(ClinicAdd, {}, `item-menu-${name}`);
        const fullPatientText = /*#__PURE__*/ _createElement(FormattedMessage, _object_spread_props(_object_spread({}, messages.sidebar.buttons.addClinic), {
            key: `item-menu-expanded-${name}`
        }));
        return this.renderMenuButtonItems(name, [
            joinClinicIcon,
            fullPatientText
        ], this.props.onAddMembership, false);
    }
    renderPatients() {
        const { activeClinicMembership } = this.props;
        const name = 'patients';
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.renderSelectedMenuHeader(name),
                /*#__PURE__*/ _jsx(SearchPatients, {
                    forId: "sidebarList",
                    activeClinicMembership: this.props.activeClinicMembership
                }),
                /*#__PURE__*/ _jsx(PatientsList, {
                    id: "sidebarList",
                    activeClinicMembership: activeClinicMembership,
                    isWithoutLoad: true,
                    showMoreButton: true,
                    onShowMoreButtonClick: ()=>this.onHideAllMenu(),
                    showNoFindedResults: true
                })
            ]
        });
    }
    renderMoreClinics() {
        const { activeOrganizationUID } = this.props;
        const name = 'otherClinics';
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                this.renderSelectedMenuHeader(name),
                /*#__PURE__*/ _jsx(SearchClinics, {
                    forId: "sidebarList",
                    activeClinicMembership: this.props.activeClinicMembership
                }),
                this.activeClinics.filter((membership)=>membership.organizationUID !== activeOrganizationUID).map((membership)=>/*#__PURE__*/ _jsx(MoreClinicItem, {
                        membership: membership,
                        onClick: ()=>this.onHideAllMenu()
                    }, `menu-clinic-${membership.organizationUID}`))
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.container,
            children: this.renderContent()
        });
    }
    constructor(props){
        super(props);
        this.memberships = [];
        this.membershipOrganizations = [];
    }
}
_define_property(HcpSidebar, "propTypes", {
    // Explicit props
    direction: PropTypes.string,
    menuOpen: PropTypes.bool,
    selectedMenuItem: PropTypes.string,
    // Explicit actions
    setMenuOpen: PropTypes.func,
    setSelectedMenuItem: PropTypes.func,
    // Implicit props
    activePatient: PropTypes.shape({
        id: PropTypes.string,
        avatar: PropTypes.string,
        email: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string
    }),
    hcpClinicMemberships: PropTypes.arrayOf(Account.shapes.clinicMembership),
    organizationMemberships: PropTypes.arrayOf(PropTypes.object),
    activeClinicMembershipId: PropTypes.number,
    activeOrganizationUID: PropTypes.string,
    activeClinicMembership: Account.shapes.clinicMembership,
    activeOrganizationMembership: PropTypes.object,
    isClinicAdmin: PropTypes.bool,
    passphrase: PropTypes.string,
    isConnectToClinicInProgress: PropTypes.bool,
    hasConnectToClinicErrors: PropTypes.bool,
    openModalId: PropTypes.string,
    route: App.shapes.route,
    intl: intlShape,
    search: PropTypes.string,
    // Implicit actions
    onAddPatient: PropTypes.func,
    onAddMembership: PropTypes.func,
    onFetchMemberships: PropTypes.func,
    onConnect: PropTypes.func,
    onDisconnect: PropTypes.func,
    onFetchPatients: PropTypes.func
});
const mapStateToProps = (state)=>({
        activePatient: Hcp.selectors.activePatient(state),
        search: Hcp.selectors.searchClinicsSelector('sidebarList')(state),
        hcpClinicMemberships: Account.selectors.hcpClinicMemberships(state),
        organizationMemberships: Account.selectors.organizationMembershipsPending(state),
        activeClinicMembershipId: Account.selectors.activeClinicMembershipId(state),
        activeOrganizationUID: Account.selectors.activeOrganizationUID(state),
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        activeOrganizationMembership: Account.selectors.activeOrganizationMembership(state),
        isClinicAdmin: Account.selectors.isClinicAdmin(state),
        passphrase: Account.selectors.passphrase(state),
        isConnectToClinicInProgress: Account.selectors.isConnectToClinicInProgress(state),
        hasConnectToClinicErrors: Account.selectors.hasConnectToClinicErrors(state),
        openModalId: App.selectors.modal(state),
        route: App.selectors.route(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onAddPatient: ()=>dispatch(App.actions.openModal(Hcp.constants.INVITE_PATIENT_MODAL)),
        onAddMembership: ()=>dispatch(Account.actions.addAidOrganizationMembership()),
        onFetchMemberships: ()=>dispatch(Account.actions.fetchMemberships()),
        onConnect: (clinicMembership)=>{
            if (clinicMembership && clinicMembership.membershipStatus === 'Active' && (clinicMembership.clinic.storageAccount || clinicMembership.isAdmin)) {
                dispatch(Account.actions.connectToClinic(clinicMembership));
            }
        },
        onDisconnect: ()=>dispatch(Account.actions.disconnectClinic()),
        onFetchPatients: (clinicMembership)=>Promise.all([
                dispatch(Hcp.actions.fetchPatients(clinicMembership)),
                dispatch(Hcp.actions.fetchEnrollingSharingRequests(clinicMembership))
            ])
    });
const ConnectedHcpSidebar = connect(mapStateToProps, mapDispatchToProps)(injectIntl(HcpSidebar));
export default withStyles(styles)(ConnectedHcpSidebar);
